// export const distanceToSimilarity = (distance) => (1/(1+distance))

export const distanceToSimilarity = (distance) => 1/(1+distance)

export const pluralize = (word, count) => {
    return <>{count} {word}{count>1?'s':''}</>
}